module.exports = __webpack_public_path__ + "static/media/announce-icon.b7534736.svg";